<!-- eslint-disable -->
<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">
          {{ item.meta.title }}
        </span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
/* eslint-disable */

import pathToRegexp from 'path-to-regexp';

export default {
  name: 'Breadcrumb',
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name);

      const first = matched[0];
      const isMobiluce = matched.some(
        m => m.path && m.path.includes('mobiluce')
      );
      if (!isMobiluce && first && first.name.trim().toLocaleLowerCase() !== 'Accueil'.toLocaleLowerCase()) {
        matched = [{ path: '/dashboard', meta: { title: 'Accueil' }}].concat(matched);
      }

      this.levelList = matched.filter(
        item => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
    },
    pathCompile(path) {
      const { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
      const { redirect, path } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;

  .no-redirect {
    color: var(--app-text-color-secondary, #606266);
    cursor: text;
    font-weight: 500;
  }

  a {
    color: var(--proso-dark, #02264a);
    font-weight: 500;
    transition: color 0.2s;

    &:hover {
      color: var(--proso-turquoise, #6ed6ce);
    }
  }

  :deep(.el-breadcrumb__separator) {
    color: var(--app-text-color-secondary, #606266);
    font-weight: bold;
    margin: 0 8px;
  }

  :deep(.el-breadcrumb__item) {
    .el-breadcrumb__inner {
      font-weight: 500;
      color: var(--app-text-color-secondary, #606266);

      &:hover {
        color: var(--proso-dark, #02264a);
      }
    }

    &:last-child {
      .el-breadcrumb__inner {
        color: var(--app-text-color, #303133);
        font-weight: 600;
      }
    }
  }
}

/* Dark mode - texte blanc pour contraste sur fond bleu foncé */
:global(html.dark) .app-breadcrumb.el-breadcrumb {
  .no-redirect {
    color: rgba(255, 255, 255, 0.7);
  }

  a {
    color: #ffffff;

    &:hover {
      color: #6ed6ce;
    }
  }

  :deep(.el-breadcrumb__separator) {
    color: rgba(255, 255, 255, 0.5);
  }

  :deep(.el-breadcrumb__item) {
    .el-breadcrumb__inner {
      color: rgba(255, 255, 255, 0.7);

      &:hover {
        color: #ffffff;
      }
    }

    &:last-child {
      .el-breadcrumb__inner {
        color: #ffffff;
      }
    }
  }
}
</style>
